import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'store';

import RadioButton from 'components/RadioButton';
import { PaymentCard } from 'models/paymentCard';
import { cardTypeNormalize } from 'utils/payment';

import PaymentCardFlag from '../PaymentCardFlag';
import { Container, Header } from './styles';

export interface PaymentCardProps {
  onClick?: () => void;
  card?: PaymentCard;
  isSelectable?: boolean;
  isSelected?: boolean;
  iconType?: string;
  placeholder?: string;
  icon?: string;
  title?: string;
}

const PaymentCardItem = ({
  onClick,
  card,
  isSelectable,
  isSelected,
  iconType,
  placeholder,
  icon,
  title,
}: PaymentCardProps) => {
  const accountResult = useSelector((state: RootState) => state.user.accountResult);

  if (typeof card === 'undefined') {
    if (typeof title !== 'undefined') {
      return (
        <Container>
          <Header onClick={onClick}>
            <Header.Icon src={icon} alt="" />
            <Header.Title>{title}</Header.Title>
            <Header.ArrowIcon empty />
          </Header>
        </Container>
      );
    }
    return (
      <Container>
        <Header onClick={onClick}>
          <Header.Icon src="/corporate/images/list-preview-icons/card-disabled.svg" alt="" />
          <Header.Placeholder empty>{placeholder}</Header.Placeholder>
          <Header.ArrowIcon empty />
        </Header>
      </Container>
    );
  }

  let { cardType } = card;
  cardType = cardTypeNormalize(cardType);

  return (
    <Container>
      <Header onClick={onClick}>
        <PaymentCardFlag card={card} countryCode={accountResult.countryId} />
        <Header.Detail>
          <div>
            <Header.Title>
              {cardType.toUpperCase()} *{card.last4Digits}
            </Header.Title>
            {card.expirationDate}
          </div>
          {card.defaultCC ? <Header.DefaultCard /> : null}
        </Header.Detail>
        {isSelectable ? (
          <RadioButton value={`${card.id}`} isChecked={isSelected} />
        ) : iconType === 'empty' ? null : iconType === 'dots' ? (
          <Header.DotsIcon />
        ) : (
          <Header.ArrowIcon />
        )}
      </Header>
    </Container>
  );
};
export default PaymentCardItem;
